import { defineComponent, h } from '@vue/composition-api';
import { withInstall } from '../util/index.js';

var Progress = defineComponent({
  name: 'm-progress',
  props: {
    text: {
      type: String
    },
    lineWidth: {
      type: Number,
      "default": 5
    },
    size: {
      type: Number,
      "default": 60
    },
    percent: {
      type: Number,
      "default": 0
    },
    backgroundColor: {
      type: String,
      "default": 'rgba(255, 255, 255, 0.24)'
    },
    frontColor: {
      type: String,
      "default": '#fff'
    }
  },
  setup: function setup(props) {
    return function () {
      var size = props.size,
          lineWidth = props.lineWidth,
          backgroundColor = props.backgroundColor,
          frontColor = props.frontColor,
          text = props.text; // 圆心

      var center = size / 2; // 半径

      var r = center - lineWidth; // 进度百名比

      var percent = props.percent / 100; // 周长

      var perimeter = Math.PI * 2 * r; // 根据百分比计算长度

      var dasharray = "".concat(perimeter * percent, " ").concat(perimeter * (1 - percent));
      var displayText = text || "".concat(props.percent, "%");
      return h("div", {
        "class": "m-progress"
      }, [h("svg", {
        "attrs": {
          "width": size,
          "height": size
        }
      }, [h("circle", {
        "attrs": {
          "cx": center,
          "cy": center,
          "r": r,
          "stroke-width": lineWidth,
          "stroke": backgroundColor,
          "fill": "none"
        }
      }), h("circle", {
        "attrs": {
          "cx": center,
          "cy": center,
          "r": r,
          "stroke-width": lineWidth,
          "stroke": frontColor,
          "fill": "none",
          "transform": "matrix(0,-1,1,0,0,".concat(size, ")"),
          "stroke-dasharray": dasharray
        }
      })]), h("div", {
        "class": "m-progress__text"
      }, [displayText])]);
    };
  }
});
withInstall(Progress);

export { Progress as default };
//# sourceMappingURL=index.js.map
